/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobListRequest {
    getFixupPrototypeFunction() { return PolicyJobListRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobListRequest>): PolicyJobListRequest {
        let obj = Object.assign(new PolicyJobListRequest(), model);
        PolicyJobListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobListRequest>): PolicyJobListRequest {
        if (!model) return null;
        return PolicyJobListRequest.newInstance(<PolicyJobListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobListRequest) {
        if (!obj) return;

        models.PolicyJobListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobListRequest): boolean {
        Object.setPrototypeOf(obj, PolicyJobListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.PolicyJobListFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.PolicyJobListSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.PolicyJobListSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.PolicyJobListFilter;

}
